<template>
    <div class="NotificationContainer">
        <NotificationBar
            v-for="notification in notifications"
            :notification="notification"
            :key="notification.id"
        />
    </div>
</template>

<script>

    import NotificationBar from "./NotificationBar";
    import {mapState} from 'vuex';

    export default {
        name: "NotificationContainer",
        components: {NotificationBar},
        computed: mapState('Notification', ['notifications'])
    }
</script>